import { getAPIService, putAPIService } from "./BaseServce";

export type BannerType = "announcement" | "promotion" | "warning" | "critical";

export interface Banner {
  id: number;
  banner_type: BannerType;
  content: string;
  is_dismissible: boolean;
  created: string;
}

export const getBanners = async (): Promise<Banner[]> => {
  const res = await getAPIService("/banners");
  return res.data as Banner[];
};

export const dismissBanner = async (id: number) => {
  await putAPIService(`/banners/${id}/dismiss`, {});
};
